import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Header from "./components/header/Header";
import { Outlet, useLocation } from "react-router-dom";
import "./layout.scss";
import ProgressiveLoader from "./components/loader/ProgressiveLoader";
import { isPhoneJs } from "./utlis/resolution";
import {
  PERSON_DASHBOARD,
  ACTIVITY_MONITORING,
  ACTIVITY_TREND,
  TUG_FRONT_INFO,
  TUG_SIDE_INFO,
  HOW_TO_TEST_TUG_FRONT,
  HOW_TO_TEST_TUG_SIDE,
  LOGIN,
  SIGNUP,
  FORGOT_PASSWORD,
  ADD_TEST_PERSON,
  EDIT_TEST_PERSON,
  VIEW_TEST_PERSON,
  TEST_HISTORY,
  USER_LIST,
  ADMIN_CHOICE,
} from "./routes/routerPath";

const Layout = () => {
  const location = useLocation();
  const loader = useSelector((state) => state.global.loading);
  const [isPhone, setIsPhone] = useState(isPhoneJs());
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {
    const handleResize = () => {
      setIsPhone(isPhoneJs());
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  const headerHandler = () => {
    if (
      path === "/" ||
      path === LOGIN ||
      path === SIGNUP ||
      path === FORGOT_PASSWORD ||
      path === ADMIN_CHOICE ||
      path === USER_LIST ||
      path === ADD_TEST_PERSON ||
      path === EDIT_TEST_PERSON ||
      path === VIEW_TEST_PERSON ||
      path === PERSON_DASHBOARD ||
      path === ACTIVITY_MONITORING ||
      path === ACTIVITY_TREND ||
      path === TUG_FRONT_INFO ||
      path === TUG_SIDE_INFO ||
      path === HOW_TO_TEST_TUG_FRONT ||
      path === HOW_TO_TEST_TUG_SIDE ||
      path === TEST_HISTORY
    ) {
      return false;
    }
    if (isPhone) {
      return false;
    }
    return true;
  };
  const isFullWidthPath =
    path === "/" ||
    path === LOGIN ||
    path === SIGNUP ||
    path === FORGOT_PASSWORD ||
    path === ADMIN_CHOICE ||
    path === USER_LIST ||
    path === ADD_TEST_PERSON ||
    path === EDIT_TEST_PERSON ||
    path === VIEW_TEST_PERSON;
  return (
    <div className={`layout-wrapper ${isFullWidthPath ? "full-width" : ""}`}>
      {headerHandler() && <Header />}
      <Outlet />
      {loader && <ProgressiveLoader loader={loader} />}
    </div>
  );
};

export default Layout;
